.banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-card);
}

.icon {
  align-self: flex-start;
  margin-top: 1px;
}

.text {
  flex: 1 1 24ch;
  font: var(--text-callout);
  color: var(--label);
  text-wrap: pretty;
}

.action {
  margin-left: auto;
}

.atencao {
  background: color-mix(in srgb, var(--warn-mark) 14%, var(--card));
}

.atencao .icon {
  color: var(--warn-mark);
}

.negativo {
  background: color-mix(in srgb, var(--neg-mark) 11%, var(--card));
}

.negativo .icon {
  color: var(--neg-mark);
}

.outros {
  background: var(--card);
  box-shadow: var(--shadow-card);
}

.outros .icon {
  color: var(--other-mark);
}
